export const POLL_MS = 5 * 60 * 1000;
export const REMINDER_MS = 60 * 60 * 1000;
export const SNOOZE_STORAGE_KEY = "pv-doc-upload-snooze-until";

export const DOCUMENT_MAPPING_ROLES = new Set([
  "admin",
  "coordinator",
  "project_manager",
  "ticket_coordinator",
  "partner_allocation_coordinator",
  "qa",
]);

/** PM and admin may map uploads from the dismissed queue on Document Mapping page. */
export const DISMISSED_MAPPING_ROLES = new Set(["admin", "project_manager"]);
